import jsonQuery from 'json-query';
import global from '../../constants/global';

export default function getPageHierarchy(currenturl, locale, pageType = null) {
  let urlLevel = '';
  const url = {
    siteurl: require(`../../data/${locale}/url.json`),
  };
  const pageData = [];

  let breadcrumbItem = currenturl.split('/');
  breadcrumbItem = breadcrumbItem.filter(x => x !== '');
  let notFoundSlug = '';
  breadcrumbItem.forEach(e => {
    let page = null;
    if (e) {
      if (locale && e === locale.toLowerCase()) {
        urlLevel = `/${locale.toLowerCase()}`;
        page = {
          slug: 'Página Inicial',
          breadCrumbTitle: 'Página Inicial',
          parentSlug: null,
          path: `/${locale.toLowerCase()}`,
        };
      } else {
        urlLevel = `${urlLevel}/${e}`;
        page = jsonQuery(`siteurl[**][${e}][path=${urlLevel}]`, {
          data: url,
        }).value;
        if (!page) {
          page = jsonQuery(`siteurl[**][path=${urlLevel}]`, {
            data: url,
          }).value;
        }
        if (!page) {
          page = jsonQuery(
            `siteurl[**][${notFoundSlug}/${e}][path=${urlLevel}]`,
            {
              data: url,
            }
          ).value;
        }
        if (!page && pageType === global.contentType.productPage) {
          page = jsonQuery(
            `siteurl[**][${
              breadcrumbItem[breadcrumbItem.length - 2]
            }/${e}][path=${urlLevel}]`,
            {
              data: url,
            }
          ).value;
        }
        if (!page) {
          const currentPageSlug = global.pageSlug[e];
          if (currentPageSlug) {
            page = {
              slug: e,
              breadCrumbTitle: currentPageSlug.breadCrumbTitle,
              parentSlug: null,
              path: currenturl,
            };
          } else {
            notFoundSlug = e;
          }
        }
      }
      if (page) {
        pageData.push(page);
      }
    }
  });
  return pageData;
}
